import React, { memo } from 'react';
import { Button, HoiPoiProvider } from '@Sage/hoi-poi-ui';

import AbsoluteEmpty from 'components/AbsoluteEmpty';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const reloadApplication = () => window.location.reload();

// Rendered above every provider, so it carries its own theme provider.
const AppErrorFallback = memo(({ onReload = reloadApplication }) => (
    <HoiPoiProvider>
        <main className="fm-app-error-fallback">
            <AbsoluteEmpty
                actions={[
                    <Button key="reload-app" onClick={onReload}>
                        {getLiteral('action_refresh')}
                    </Button>,
                ]}
            />
        </main>
    </HoiPoiProvider>
));

AppErrorFallback.displayName = 'AppErrorFallback';

export default AppErrorFallback;
